var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNpTextMessage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.459,
    height: 10.743,
    viewBox: "0 0 11.459 10.743",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_text-message_4588896_000000",
    transform: "translate(-17.998 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5724",
    "data-name": "Path 5724",
    d: "M40.716,39.432h3.223a.716.716,0,0,0,0-1.432H40.716a.716.716,0,0,0,0,1.432Z",
    transform: "translate(-18.063 -14.777)",
    fill: "#5636d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5725",
    "data-name": "Path 5725",
    d: "M40.716,55.432h3.223a.716.716,0,0,0,0-1.432H40.716a.716.716,0,0,0,0,1.432Z",
    transform: "translate(-18.063 -27.912)",
    fill: "#5636d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5726",
    "data-name": "Path 5726",
    d: "M19.683,30.743H26.95a2.507,2.507,0,0,0,2.507-2.507V22.507A2.507,2.507,0,0,0,26.95,20H21.579a2.507,2.507,0,0,0-2.507,2.507v4.779l-.58.58a1.685,1.685,0,0,0,1.19,2.877ZM19.5,28.879l.926-.926h0a.251.251,0,0,0,.073-.179V22.507a1.075,1.075,0,0,1,1.074-1.074H26.95a1.075,1.075,0,0,1,1.074,1.074v5.729A1.075,1.075,0,0,1,26.95,29.31H19.683a.253.253,0,0,1-.179-.432Z",
    fill: "#5636d0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNpTextMessage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/np_text-message.ccff4a68.svg";
export { ForwardRef as ReactComponent };